import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHtmlBold = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 10 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "nonzero",
		d: "M8.06503 5.67565c.9141-.49653 1.45807-1.45071 1.45807-2.5632 0-1.29204-.71332-2.34713-1.86484-2.79051C6.98745.05384 6.32742 0 5.47992 0H.43478C.19465 0 0 .19187 0 .42857v.88524c0 .2367.19465.42857.43478.42857h.89981v8.53206H.4348C.19464 10.27444 0 10.4663 0 10.703v.86842C0 11.80813.19465 12 .43478 12h5.31767c.65769 0 1.21831-.03453 1.817-.20314C8.95436 11.3891 10 10.14233 10 8.51823c0-1.39736-.7221-2.45582-1.93497-2.84258zM3.6472 1.8431h1.83272c.44277 0 .74826.05408 1.0197.17992.4301.22711.6768.70987.6768 1.32444 0 .93828-.55218 1.52116-1.44101 1.52116H3.6472V1.8431zm3.06092 8.18236c-.27554.10865-.61622.13144-.8535.13144H3.6472v-3.462h2.29258c1.07731 0 1.7135.67982 1.7135 1.68903.00004.76138-.37119 1.4058-.94515 1.64153z"
	})
});
export default SvgIconHtmlBold;
